import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

import User from './user-model';
import UserActions from './user-actions';

const initialState = Immutable({ active: User.create({}) });

const reducer = createReducer(on => {
  on(UserActions.fetchCurrentUserSuccess, (state, { user }) => {
    return state.set('active', user);
  });
}, initialState);

export default reducer;
